import { FC } from 'react'
import { Table } from 'antd'
import { SortOrder } from 'antd/lib/table'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../../context/auth-context'
import { LatestContractDtoFragment, Change } from '../../../types'
import { useDateTime } from '../../../shared/useDateTime'
import { ContractChangeList } from '../../../modules/appraisal/contract/ContractChangeList'

interface Props {
  contractChange: Pick<Change, 'id' | 'validFrom' | 'changes' | 'status' | 'type' | 'updatedDate'>[]
  latestContract?: LatestContractDtoFragment
}

export const MeetingStatusModalContractChange: FC<Props> = ({ contractChange, latestContract }) => {
  const [t] = useTranslation()
  const { user } = useAuth()
  const { formatDateShort } = useDateTime(user)

  const columns = [
    {
      key: 'validFrom',
      title: t('appraisalMeeting.contract.changes.table.from'),
      defaultSortOrder: 'ascend' as SortOrder,
      render: (rowData: Pick<Change, 'id' | 'validFrom' | 'changes' | 'status' | 'type' | 'updatedDate'>) =>
        rowData.validFrom && formatDateShort(rowData.validFrom, true),
    },
    {
      key: 'change',
      title: t('appraisalMeeting.contract.changes.table.change'),
      render: (rowData: Pick<Change, 'id' | 'validFrom' | 'changes' | 'status' | 'type' | 'updatedDate'>) => (
        <ContractChangeList
          raw={rowData.changes}
          user={user}
          nationalContractReferenceLevel={
            latestContract && latestContract.hasNationalContract && latestContract.nationalContractReferenceLevel
              ? latestContract.nationalContractReferenceLevel.description
              : undefined
          }
          isConclusion={false}
          isPreparation={false}
          contract={latestContract}
        />
      ),
    },
  ]

  return (
    <Table
      dataSource={contractChange.map((change, index: number) => ({ ...change, key: index }))}
      className="fullWidth"
      columns={columns}
      pagination={false}
      data-e2e-contract-change-table
    />
  )
}
